import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import $ from 'jquery';

import Master from '../Master';
import Collapsible from '../Panels/Collapsible';
import IziToast from '../IziToast';
import Select from '../Select';
import TransTable from './TransTable';
import DatePicker from '../DatePicker';
import Button from '../Buttons';
import AlertMessage from '../Alert';
import AlertActions from '../../actions/alert';
import { DestroyTable, DateTimeUTC, SortByLatest } from '../../utils/Functions';

const Transactions = ({ user, dispatch, alert }) => {
  // token
  const userToken = user ? user.token : {};
  const requestConfig = {
    headers: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json',
    },
  };

  //   refs
  const propertyRef = useRef(null);
  const tenantRef = useRef(null);

  // state
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const [lowerDate, setLowerDate] = useState(firstDay);
  const [upperDate, setUpperDate] = useState(lastDay);
  const [propertyId, setPropertyId] = useState('');
  const [properties, setProperties] = useState([]);
  const [tenantId, setTenantId] = useState('');
  const [tenants, setTenants] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tenantsList, setTenantsList] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [units, setUnits] = useState([]);

  useEffect(() => {
    dispatch(AlertActions.clear());
  }, [dispatch]);

  useEffect(() => {
    (async () => {
      try {
        let url = `/byuser?status=active&user_id=${user.id}`;
        if (user && user.type === 'admin') {
          url = '?take=1000&where={"status":"active"}&order={"name":"ASC"}';
        }
        const {
          data: { response },
        } = await axios.get(
          `${process.env.REACT_APP_API_URL}properties${url}`,
          requestConfig,
        );
        setProperties(response);
        loadUnits(response);
        $(propertyRef.current)
          .select2()
          .on('change', (event) => {
            setPropertyId(event.val);
          });
      } catch (_) {
        IziToast('Could not load your properties');
      }
    })();
  }, []);

  useEffect(() => {
    filterByProperty();
    setTenantId('');
  }, [propertyId]);

  useEffect(() => {
    if (tenantId) {
      DestroyTable('transactions_table');
      const transaction = transactionList.filter((item) => {
        if (item && item.tenant) {
          return item.tenant.id === tenantId;
        }
        return undefined;
      });
      setTransactions(transaction);
    } else if (propertyId) {
      filterByProperty();
    } else {
      setTransactions(transactionList);
    }
  }, [tenantId]);

  useEffect(() => {
    if (transactions.length > 0) {
      const sum = transactions.reduce((acc, curr) => {
        return parseFloat(acc) + parseFloat(curr.amount);
      }, 0);
      setTotal(sum);
    } else {
      setTotal(0);
    }
  }, [transactions]);

  function filterByProperty() {
    if (propertyId) {
      DestroyTable('transactions_table');
      const filtered = tenantsList.filter((item) => {
        return item.unit.property_id === propertyId;
      });
      dispatch(AlertActions.clear());
      setTenants(filtered);
      const transaction = transactionList.filter((item) => {
        if (item && item.property) {
          return item.property.id === propertyId;
        }
        return undefined;
      });
      setTransactions(transaction);
    } else {
      dispatch(AlertActions.clear());
      setTenants(tenantsList);
      setTransactions(transactionList);
    }
  }

  /**
   *
   * @param {[]} property
   */
  async function loadUnits(property) {
    const propertyIds = property.map((item) => {
      return item.id;
    });
    let urlUnits;
    // get units
    if (user.type === 'admin') {
      urlUnits = `${process.env.REACT_APP_API_URL}units?take=10000`;
    } else {
      urlUnits = `${process.env.REACT_APP_API_URL
        }units?take=10000&where={"property_id":"in::${propertyIds.join()}"}`;
    }
    try {
      const {
        data: { response: unitsInfo },
      } = await axios.get(urlUnits, requestConfig);
      setUnits(unitsInfo);
      loadTenants(unitsInfo);
    } catch (_) {
      //
    }
  }

  /**
   *
   * @param {[]} unitsInfo
   */
  function loadTenants(unitsInfo) {
    function searchUnit(id) {
      return unitsInfo.find((item) => {
        return item.id === id;
      });
    }

    (async () => {
      try {
        const unitIds = unitsInfo.map((item) => {
          return item.id;
        });
        let urlTenants;
        // get tenats
        if (user.type === 'admin') {
          urlTenants = `${process.env.REACT_APP_API_URL}tenants?take=10000`;
        } else {
          urlTenants = `${process.env.REACT_APP_API_URL
            }tenants?take=10000&where={"unit_id":"in::${unitIds.join()}"}`;
        }
        const {
          data: { response },
        } = await axios.get(urlTenants, requestConfig);
        const mapped = response.map((item) => {
          const element = item;
          element.unit = searchUnit(element.unit_id);
          return element;
        });
        dispatch(AlertActions.clear());
        setTenants(mapped);
        setTenantsList(mapped);
        $(tenantRef.current)
          .select2()
          .on('change', (event) => {
            setTenantId(event.val);
          });
      } catch (_) {
        //
      }
    })();
  }

  function findUnit(id) {
    return units.find((item) => {
      return item.id === id;
    });
  }

  function findTenant(id) {
    return tenantsList.find((item) => {
      return item.id === id;
    });
  }

  function findProperty(id) {
    return properties.find((property) => {
      return property.id === id;
    });
  }

  async function onLoadTransaction() {
    setError(null);
    let filter = '';
    if (tenantId) {
      filter = `${filter}"tenant_id":"${tenantId}"`;
    }
    if (!lowerDate || !upperDate) {
      // no date filter
      dispatch(AlertActions.error('Select both date filters to continue'));
      return;
    }
    if (lowerDate && upperDate) {
      // filter by date
      const query = filter ? ',' : '';
      if (lowerDate && upperDate) {
        filter = `${filter}${query}"createdat":"btwn::${DateTimeUTC(
          lowerDate,
          false,
        )},${DateTimeUTC(upperDate, true)}"`;
      }
    }
    if (!filter) {
      dispatch(AlertActions.error('Select transaction filter to continue'));
      return;
    }
    if (!tenants.length > 0) {
      dispatch(AlertActions.error('Performing background sync, try again'));
      return;
    }

    try {
      setIsLoading(true);
      if (user.type !== 'admin') {
        const tenantsIds = tenants.map((item) => {
          return item.id;
        });
        filter = `${filter},"tenant_id":"in::${tenantsIds.join()}"`;
      }
      const urlPayments = `${process.env.REACT_APP_API_URL}payments?where={${filter}}`;
      const {
        data: { response },
      } = await axios.get(urlPayments, requestConfig);
      mapTransactions(response);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  }

  function mapTransactions(charges) {
    const mapped = charges.map((transaction) => {
      const element = transaction;
      const { reference_data: referenceData } = transaction;
      const { unit_id: unitId } = referenceData;
      const unit = findUnit(unitId);
      const tenant = findTenant(element.tenant_id);
      element.tenant = tenant;
      if (unit) element.property = findProperty(unit.property_id);
      return element;
    });
    const sorted = SortByLatest(mapped);
    if (propertyId) {
      const filtered = sorted.filter((item) => {
        if (item && item.property) {
          return item.property.id === propertyId;
        }
        return undefined;
      });
      setTransactions(filtered);
    } else {
      setTransactions(sorted);
    }
    setTransactionList(sorted);
    setIsLoading(false);
  }

  return (
    <Master redirectLink="transactions" title="Finance" source="Transactions">
      <div className="row">
        <div className="col-md-12">
          {alert && alert.message && (
            <AlertMessage
              alertType={`alert ${alert.type}`}
              message={alert.message}
            />
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-9">
          <div className="row">
            <Select
              caption="Property Name"
              value={propertyId}
              onChange={(event) => {
                setPropertyId(event.target.value);
              }}
              columnWidth={6}
              inputRef={propertyRef}
            >
              <option value="">Select property name</option>
              {properties.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </Select>
            <Select
              caption="Tenant"
              value={tenantId}
              onChange={(event) => {
                setTenantId(event.target.value);
              }}
              columnWidth={6}
              inputRef={tenantRef}
            >
              <option value="">Select tenant</option>
              {tenants.map((item) => {
                return (
                  <option key={item.id} value={item.id}>
                    {`${item.first_name} ${item.last_name} | ${item.other_details ? item.other_details.unit_number : '--' }`}
                  </option>
                );
              })}
            </Select>
          </div>
          <div className="row">
            <DatePicker
              placeholder="Select date from"
              caption="Date From"
              onChange={(date) => {
                return setLowerDate(date);
              }}
              columnWidth={2}
              selected={lowerDate}
            />
            <DatePicker
              placeholder="Select date to"
              caption="Date To  &nbsp; &nbsp;"
              onChange={(date) => {
                return setUpperDate(date);
              }}
              columnWidth={2}
              selected={upperDate}
            />
            <div className="col-md-3 invoice-button">
              <Button
                caption="Search"
                cssClass="btn-success"
                onClick={onLoadTransaction}
                type="button"
                isBlack={false}
              />
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="hpanel">
            <div className="panel-body">
              <span>Search Total</span>
              <br />
              <h1 className="primary-red">{`Ksh ${total.toLocaleString(undefined, { maximumFractionDigits: 2 })}`}</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <Collapsible
          columnWidth={12}
          caption="Transactions"
          controlId="transactions"
        >
          <TransTable
            isLoading={isLoading}
            error={error}
            transactions={transactions}
          />
        </Collapsible>
      </div>
    </Master>
  );
};

Transactions.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  dispatch: PropTypes.func.isRequired,
  alert: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

Transactions.defaultProps = {
  user: {},
  alert: {},
};

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps)(Transactions);
